import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { path: "/", label: "首页", icon: "ri-home-4-line" },
  { path: "/category/movie", label: "分类", icon: "ri-grid-line" },
  { path: "/about", label: "关于我们", icon: "ri-information-line" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span className="text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              红桃视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
                  isActive(item.path)
                    ? "text-primary-500 bg-primary-100/60"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center gap-2 bg-background-100 rounded-full px-4 py-2">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                type="text"
                placeholder="搜索视频..."
                className="bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 outline-none w-36"
              />
            </div>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-700"
            >
              <i className={mobileOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200 py-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? "text-primary-500 bg-primary-100/60"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                <i className={`${item.icon}`}></i>
                {item.label}
              </Link>
            ))}
            <div className="flex items-center gap-2 mx-4 mt-3 bg-background-100 rounded-full px-4 py-2.5">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                type="text"
                placeholder="搜索视频..."
                className="bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 outline-none flex-1"
              />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}